import CustomButton from 'components/Buttons/CustomButton'
import { Can } from 'context/Acl'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap'
import {
  BUSINESS_AR_AP,
  BUSINESS_MEMBER_PRODUCTION_UNIT,
  BUSINESS_PRODUCTION_UNIT,
  MANAGE,
} from 'utils/subjectActions'

import { useLocation, useNavigate } from 'react-router-dom'
import { ArrowLeft, ArrowRight } from 'react-feather'

import moment from 'moment-timezone'
import BreadCrumbs from 'components/breadcrumbs'
import { URL_FORM_PRODUCTION_UNIT, URL_PRODUCTION_UNIT } from 'utils/pathUrl'
import ModalLandPlot from 'features/private-views/farmers-web/detail/ModalLandPlot'
import { toggleModal } from './productionUnitSlice'

const DetailProductionUnit = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const isMember = location.state?.isMember || false
  const data = location.state?.data
  const { isOpenModal } = useSelector((s) => s.productionUnit)

  return (
    <div className="py-3 w-100 px-3">
      <ModalLandPlot
        row={data}
        isOpen={isOpenModal}
        toggle={() => dispatch(toggleModal())}
        isProductionUnit
      />
      <div className="d-flex align-items-start gap-2 py-3">
        {isMember ? (
          <BreadCrumbs
            breadCrumbParent2={data?.data?.fullName}
            breadCrumbActive={'Detail Unit Produksi'}
            breadCrumbParent2Link={`/farmers/${data?.data?.userId}`}
            breadCrumbParent={'Daftar Anggota'}
            breadCrumbParentLink={'/farmers'}
          />
        ) : (
          <BreadCrumbs
            breadCrumbParent2={'Unit Produksi'}
            breadCrumbActive={'Detail Unit Produksi'}
            breadCrumbParent2Link={URL_PRODUCTION_UNIT}
            breadCrumbParent={'Pengaturan'}
            breadCrumbParentLink={'/pengaturan-profile'}
          />
        )}
      </div>
      <Row className="align-items-start mb-3 ">
        <Col
          xs="12"
          md="6"
          className="d-flex gap-1 align-items-center mb-2 mb-md-0"
        >
          <ArrowLeft
            size={20}
            className="me-2"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          />
          <h6 className="fw-bold mb-0">Detail Unit Produksi</h6>
        </Col>
        <Col xs="12" md="6" className="text-md-end">
          <Can
            I={MANAGE}
            this={
              isMember
                ? BUSINESS_MEMBER_PRODUCTION_UNIT
                : BUSINESS_PRODUCTION_UNIT
            }
          >
            <CustomButton
              testId="production-unit-edit-button"
              onClick={() => {
                navigate(`${URL_FORM_PRODUCTION_UNIT}`, {
                  state: {
                    data: { ...data },
                    isMember: isMember,
                    isEdit: true,
                  },
                })
              }}
              color="primary"
            >
              Ubah Unit Produksi
            </CustomButton>
          </Can>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Card className="shadow-sm border-0 h-100" data-testid="production-unit-modal-detail">
            <CardBody>
              <h6 className="fw-semibold mb-3">Informasi Wilayah</h6>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Nama Wilayah
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {data?.landName || '-'}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Kode Wilayah
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {data?.label || '-'}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Luas Wilayah
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {Number(data?.size) === 0
                    ? '0 Ha (0 km²)'
                    : `${intl.formatNumber(data.size / 10000, {
                        useGrouping: 'always',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })} Ha (${intl.formatNumber(data.size / 1000000, {
                        useGrouping: 'always',
                        minimumFractionDigits: data.size / 1000000 < 1 ? 4 : 2,
                        maximumFractionDigits: data.size / 1000000 < 1 ? 4 : 2,
                      })} km²)`}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Lokasi
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {data?.location || '-'}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Terakhir diubah oleh
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {data?.plotterName || '-'}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Kode
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {data?.code || '-'}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Tanggal Dibuat
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {data?.createdAt
                    ? moment(data.createdAt, 'DD-MM-YYYY HH:mm')
                        .locale('id')
                        .format('DD MMM YYYY, HH:mm')
                    : '-'}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Mulai Pencatatan
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {data?.startRecordTime
                    ? moment(data.startRecordTime, 'DD-MM-YYYY HH:mm')
                        .locale('id')
                        .format('DD MMM YYYY, HH:mm')
                    : '-'}
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Selesai Pencatatan
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {data?.endRecordTime
                    ? moment(data.endRecordTime, 'DD-MM-YYYY HH:mm')
                        .locale('id')
                        .format('DD MMM YYYY, HH:mm')
                    : '-'}
                </Col>
              </Row>
              <CustomButton
                outline
                color="primary"
                testId="production-unit-detail-modal-button"
                style={{ width: '100%' }}
                onClick={() => {
                  dispatch(toggleModal())
                }}
              >
                Lihat Wilayah <ArrowRight />
              </CustomButton>
            </CardBody>
          </Card>
        </Col>

        <Col md="6">
          <Card className="shadow-sm border-0 h-100">
            <CardBody>
              <h6 className="fw-semibold mb-3">Rincian Barang</h6>
              {data?.landplottingitem?.length > 0 ? (
                <ul className="m-0 ps-3">
                  {data.landplottingitem.map((item) => (
                    <li key={item.itemId}>
                      {item.nameItem} - {item.amount} {item.unit}
                    </li>
                  ))}
                </ul>
              ) : (
                <span>-</span>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default DetailProductionUnit
